import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import SiteConstants from '../../../../common/SiteConstants/SiteConstants';
import {
  StockItem,
  StockItemFormat,
} from '../../../../common/types/StockItemTypes';
import { LegacyPrimaryButton as PrimaryButton } from '../../../../storywind';
import { ExportStatus } from '../../../DetailsTypes';
import {
  selectDetailsAcquisitionOption,
  selectDetailsCanExportToCloud,
  selectDetailsCloudExportStatus,
  selectDetailsCloudExportSubfolders,
  selectDetailsCloudExportSubfolderStatus,
} from '../../../selectors/detailsSelectors';
import { selectDetailsStockItem } from '../../../selectors/detailsSelectors';
import CloudExportButton from './CloudExportButton';

import './member-upgrade-download.less';

type Props = {
  primaryActionHandler: (event) => void;
  selectedAcquisitionOption: StockItemFormat;
  canExportToCloud: boolean;
  cloudExportSubfolders: any[];
  cloudExportStatus: ExportStatus;
  cloudExportSubfolderStatus: object;
  dispatch: Dispatch;
  stockItem: StockItem;
};

class MemberDownloadUpgradeCTA extends Component<Props> {
  render() {
    return (
      <div className="memberDownloadCta">
        <div className="memberDownloadCta-cta">
          <PrimaryButton
            className="rounded-lg"
            aria-label={['Download', this.props.stockItem.title].join(' - ')}
            label="Download"
            onClick={this.props.primaryActionHandler}
          />
        </div>
        {this.exportToCloudButton()}
        <div className="memberDownloadCta-detailActions">
          {this.props.children}
        </div>
      </div>
    );
  }

  async memberLibraryExport(exportSubfolder = '') {
    const dataBridge = await SiteConstants.buildInstance().getDataBridge();
    dataBridge.exportItem(
      this.props.selectedAcquisitionOption.exportUrl,
      this.props.dispatch,
      exportSubfolder
    );
  }

  exportToCloudButton() {
    if (!this.props.canExportToCloud) {
      return null;
    }
    const {
      cloudExportSubfolders = [],
      cloudExportStatus,
      cloudExportSubfolderStatus = {},
    } = this.props;

    if (cloudExportSubfolders.length) {
      return cloudExportSubfolders.map((exportSubfolder) => {
        return (
          <CloudExportButton
            key={`exportSubfolder-${exportSubfolder}`}
            subfolder={exportSubfolder}
            status={cloudExportSubfolderStatus[exportSubfolder]}
            onClick={() => this.memberLibraryExport(exportSubfolder)}
          />
        );
      });
    }

    return (
      <CloudExportButton
        status={cloudExportStatus}
        onClick={this.memberLibraryExport}
      />
    );
  }
}

export const mapStateToProps = (state) => ({
  canExportToCloud: selectDetailsCanExportToCloud(state),
  cloudExportSubfolders: selectDetailsCloudExportSubfolders(state),
  cloudExportStatus: selectDetailsCloudExportStatus(state),
  cloudExportSubfolderStatus: selectDetailsCloudExportSubfolderStatus(state),
  selectedAcquisitionOption: selectDetailsAcquisitionOption(state),
  stockItem: selectDetailsStockItem(state),
});

export default connect(mapStateToProps)(MemberDownloadUpgradeCTA);
